import React from 'react'
import LocationIcon from '../MenuImages/Marker.png';
import PhoneIcon from '../MenuImages/Phone.png';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import '../../fonts/font.css'
import './cards.css';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ForwardIcon from '../../images/NavBarImages/Forward_100px.png';
const SearchPanel = ({ Items, SelectedType, ShowDetails, LanguageID, SelectedDepartment, SearchedItem, RestInformation, ThemeColor }) => {
    return (

        <div>




            {SelectedType === 'SearchPanel' && (

                <div >

                    <div className='row' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginBottom: '8px' }}>


                        <div className='col' style={{ textAlign: 'center', width: 230 }}>
                            {(LanguageID == 1) && (
                                <TextField style={{ direction: 'rtl', minWidth: '100%' }} label="بحث" type='string' value={SearchedItem} required onChange={(e) => ShowDetails('SearchItem', e.target.value)} />
                            )}
                            {(LanguageID == 2) && (
                                <TextField style={{ direction: 'rtl', minWidth: '100%' }} label="Search" type='string' value={SearchedItem} required onChange={(e) => ShowDetails('SearchItem', e.target.value)} />
                            )}
                            {(LanguageID == 3) && (
                                <TextField style={{ direction: 'rtl', minWidth: '100%' }} label="گەڕان" type='string' value={SearchedItem} required onChange={(e) => ShowDetails('SearchItem', e.target.value)} />
                            )}
                        </div>
                        <div className='col' style={{ textAlign: 'center',marginRight:'10px' }}>

                            <button onClick={() => ShowDetails('Group', SelectedDepartment)} style={{
                                width: '50px', height: '50px', borderRadius: '4px', backgroundColor: `#${ThemeColor}`, position: 'absolute', display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                top: '3vh',
                                right: '4vw',
                            }} type="button">  <img src={ForwardIcon} alt="Icon" /> </button>
                        </div>


                    </div>


                    <div className='row' style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                    }}>
                        {Items.map((item) => (
                            <div>
                                <Card sx={{
                                    minWidth: 300, maxWidth: 300, minWidth: 300, margin: '8px',

                                    backgroundColor: (item.availble == 0 || RestInformation.availble == 0) ? 'lightgrey' : 'white',
                                    opacity: (item.availble == 0 || RestInformation.availble == 0) ? 0.5 : 1,
                                    pointerEvents: (item.availble == 0 || RestInformation.availble == 0) ? 'none' : 'auto'

                                }} onClick={() => ShowDetails('Details', item.itemID, item)}>

                                    <CardActionArea>
                                        {(LanguageID == 1 || LanguageID == 3) && (
                                            <div className='row' style={{ display: 'flex' }}>

                                                <div className='col'   >

                                                    <img src={item.imageUrl} alt="Logo" style={{ borderRadius: '10px', maxHeight: 100, minHeight: 100, maxWidth: 100, minWidth: 100, margin: '8px' }} />
                                                    <label
                                                        style={{
                                                            fontFamily: 'basheer',
                                                            fontSize: '12pt',
                                                            position: 'absolute',
                                                            bottom: '5px',
                                                            right: '5px',
                                                            color: 'white',
                                                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                            paddingTop: '1px',
                                                            paddingLeft: '1px',
                                                            paddingRight: '1px',
                                                            borderRadius: '5px'


                                                        }}
                                                    >
                                                        {item.itemPrice}
                                                    </label>




                                                </div>


                                                <div className='col' style={{ minWidth: '60%' }}>
                                                    <div className='row' style={{ fontSize: '16px', textAlign: 'end', fontWeight: 'bold', marginRight: '2px', marginTop: '5PX' }}>
                                                        {(LanguageID == 1) && (

                                                            <label>{item.itemName}</label>

                                                        )}

                                                        {(LanguageID == 3) && (

                                                            <label>{item.itemNameKurdish}</label>

                                                        )}
                                                    </div>

                                                    <div className='row' style={{ fontSize: '12px', textAlign: 'end', marginRight: '2px', marginTop: '5PX' }}>


                                                        {(LanguageID == 1) && (

                                                            <label>{item.itemMem}</label>

                                                        )}

                                                        {(LanguageID == 3) && (

                                                            <label>{item.itemMemKurdish}</label>

                                                        )}
                                                    </div>





                                                </div>



                                            </div>
                                        )}
                                        {(LanguageID == 2) && (
                                            <div className='row' style={{ display: 'flex' }}>




                                                <div className='col' style={{ minWidth: '60%' }}>
                                                    <div className='row' style={{ fontSize: '16px', textAlign: 'start', fontWeight: 'bold', marginLeft: '5px', marginTop: '5px' }}>


                                                        <label>{item.itemNameEnglish}</label>




                                                    </div>

                                                    <div className='row' style={{ fontSize: '12px', textAlign: 'start', marginLeft: '5px', marginTop: '5px' }}>




                                                        <label>{item.itemMemEnglish}</label>


                                                    </div>





                                                </div>

                                                <div className='col'   >

                                                    <img src={item.imageUrl} alt="Logo" style={{ borderRadius: '10px', maxHeight: 100, minHeight: 100, maxWidth: 100, minWidth: 100, margin: '8px' }} />
                                                    <label
                                                        style={{
                                                            fontFamily: 'basheer',
                                                            fontSize: '12pt',
                                                            position: 'absolute',
                                                            bottom: '5px',
                                                            left: '5px',
                                                            color: 'white',
                                                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                            paddingTop: '1px',
                                                            paddingLeft: '1px',
                                                            paddingRight: '1px',
                                                            borderRadius: '5px'


                                                        }}
                                                    >
                                                        {item.itemPrice}
                                                    </label>




                                                </div>

                                            </div>
                                        )}

                                    </CardActionArea>

                                </Card>

                                <div>











                                </div>


                            </div>

                        ))}

                    </div>


                </div>
            )}















        </div>



    )
}


export default SearchPanel


